import store from './../game/store/index.js';
import config from './../config/config.js'


const finder = {
	install(Vue, options) {

		Vue.prototype.$finder = {
			get: function(arg, object) {
				var param = arg.split("=");
				for (let i in object) {
					let rec = object[i];
					if (rec[param[0]] == param[1]) return rec;
				}

				return {}
			},
			first: function(arg, object, debug) {
				let entries = this.all(arg, object, debug);
				return entries[Object.keys(entries)[0]] || null;
			},
			all: function(arg, object, debug) {
				if (object.constructor === Array) var listing = [];
				else var listing = {}

				for (let i in object) {
					let rec = object[i];
					let found = true;
					let key = (rec.id) ? rec.id : i;
					var value;
					let comparison_value;

					for (let param in arg) {
						comparison_value = arg[param];
						param = param.split('.');

						if (param[1] != undefined) value = rec[param[0]][param[1]];
						else value = rec[param[0]];

						if (value === undefined) found = false;
						else if (value === null) {
							if (comparison_value === null) found = (value === comparison_value);
							else if (comparison_value.constructor === Array) found = comparison_value.includes(value);
							else found = (value == comparison_value)
						}
						else if (value.constructor === Array) {
							if (comparison_value === null) found = (value === comparison_value);
							else if (comparison_value.constructor === Array) found = value.some(r=> comparison_value.indexOf(r) >= 0)
							else found = value.includes(comparison_value);
						}
						else {
							if (comparison_value === null) found = (value === comparison_value);
							else if (comparison_value.constructor === Array) found = comparison_value.includes(value);
							else found = (value == comparison_value)
						}
						if (!found) break;
					}
					if (found) {
						if (object.constructor === Array) listing.push(rec);
						else listing[key] = rec;
					}
					else {
						delete listing[key];
					}
				}

				return listing;
			},
			random: function (obj) {
				if (obj.constructor === Array) return obj[Math.floor(Math.random()*obj.length)];

				var keys = Object.keys(obj)
				return obj[keys[Math.floor(Math.random()*keys.length)]];
			},
			max: function(obj, key) {
				if (!key) {
					obj = this.order(obj);
					return Object.keys(obj)[Object.keys(obj).length - 1] || 0;
				}

				return (obj.reduce(function(a, b) { return a[key] >= b[key] ? a : b }, {}) || 0);
			},
			rank: function(n, rank, obj, key){
				let ordered = this.order(obj, key);
				ordered = this.chunk(ordered, Math.ceil(ordered.length / n));

				let segment = Math.max(Math.floor((ordered.length / n) * rank) - 1, 0) ;

				return ordered[segment];
			},
			rank_reverse: function(n, rank, obj, key){
				let ordered = this.order(obj, key).reverse();

				ordered = this.chunk(ordered, Math.ceil(ordered.length / n));

				let segment = Math.max(Math.floor((ordered.length / n) * rank) - 1, 0) ;

				return ordered[segment];
			},
			chunk(array, chunk_size){
				var results = [];
				let copy = array.slice(0);

				while (copy.length) {
					results.push(copy.splice(0, chunk_size));
				}

				return results;
			},
			order: function(obj, key) {

				if (key == 'random') {
					return obj.sort(() => Math.random() - 0.5);
				}

				if (key) {
					let obj_array = Object.keys(obj).map(i => obj[i]);
					key = key.split(',');
					obj_array = obj_array.sort(function (obj1, obj2) {
						if (key.length == 2) return obj1[key[0]] - obj2[key[0]] || obj1[key[1]] - obj2[key[1]];
						return obj1[key[0]] - obj2[key[0]];
					});

					return obj_array;
				}

				var ordered = (obj.constructor === Array) ? [] : {};

				Object.keys(obj).sort().forEach(function (i) {
					ordered[i] = obj[i];
				});

				return ordered;

			},
			next_id: function(obj) {
				return parseFloat(this.max(obj)) + 1
			},
			isCyclic: function(obj) {
				var seenObjects = [];

				function detect (obj) {
					if (obj && typeof obj === 'object') {
						if (seenObjects.indexOf(obj) !== -1) {
							return true;
						}
						seenObjects.push(obj);
						for (var key in obj) {
							if (obj.hasOwnProperty(key) && detect(obj[key])) {
								//console.log(obj, 'cycle at ' + key);
								return true;
							}
						}
					}
					return false;
				}

				return detect(obj);
			},
			avg(arr) {
				if (!arr || arr.length == 0) return 0;
				return parseInt(arr.reduce(function(a, b) { return a + b; }) / arr.length) || 0;
			},
			next(o, id) {
				var keys = Object.keys( o ),
				    idIndex = keys.indexOf( id ),
				    nextIndex = idIndex += 1;

				if(nextIndex >= keys.length) {
				    //we're at the end, there is no next
				    return null;
				}

				var nextKey = keys[ nextIndex ]
				return nextKey;
			},
			previous(o, id) {
		        var keys = Object.keys( o ),
		            idIndex = keys.indexOf( id ),
		            nextIndex = idIndex -= 1;
		        if(idIndex === 0) {
		        //we're at the beginning, there is no previous
		            return null;
		        }
		        var nextKey = keys[ nextIndex ]
		        return nextKey;
			},
			resolve(path, obj) {
				if (typeof obj !== 'object') throw 'finder.resolve: obj is not an object'
				if (typeof path !== 'string') throw 'finder.resolve: prop is not a string'

				// Replace [] notation with dot notation
				path = path.replace(/\[["'`](.*)["'`]\]/g,".$1")

				return path.split('.').reduce(function(prev, curr) {
					return prev ? prev[curr] : undefined
				}, obj || self)
			},
			is_equal(array1, array2) {
				return array1.length === array2.length && array1.sort().every(function(value, index) { return value === array2.sort()[index]});
			},
			remove(array, value) {
				let index = array.indexOf(value);
				if (index != -1) {
					array.splice(index, 1);
				}
				return array;
			},
			unique(arr, comp) {

				const unique = arr
					 .map(e => e[comp])

				   // store the keys of the unique objects
				  .map((e, i, final) => final.indexOf(e) === i && i)

				  // eliminate the dead keys & store unique objects
				  .filter(e => arr[e]).map(e => arr[e]);

				 return unique;
			},
			range(start, end)  {
				return Array(end - start + 1).fill().map((_, idx) => start + idx)
			}
		}

	}
};

export default finder;
